"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAnalyticsLiteInlineScript = getAnalyticsLiteInlineScript;

var _analyticsLite = _interopRequireDefault(require("@freshdesk/analytics-collector/dist/analytics-lite"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getAnalyticsLiteInlineScript(analyticsCollectorConfig) {
  var analyticsLite = (0, _analyticsLite.default)(analyticsCollectorConfig);
  return "<script> ".concat(analyticsLite, " </script>");
}